import React from 'react';

import GenericField from './shared/GenericField';
import BooleanInputContainer from './boolean/BooleanInputContainer';

/**
 * Booelan field input with only null/yes can be selected.
 * @param {string} [label] Label description for field input.
 * @param {string} [initialValue] Field value.
 * @param {function} [handleSave] [async bool=>{bool success, string message}] Save changes / return error message.
 */
const Boolean = ({ label, initialValue, handleSave: syncChanges }) => {
    const isSwitch = true;
    return (
        <GenericField>
            {label}
            <BooleanInputContainer {...{ initialValue, syncChanges, isSwitch }} />
        </GenericField>
    );
};

export default Boolean;
